import { Divider } from "antd";
import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { selectViewMode } from "../../../../util/store/selectors";
import { getStore } from "../../../../util/store/store";
import { VIEW_MODE, viewModes } from "../../../../util/varibles/permission";
import { PreferenceSetting } from "../../../../util/varibles/userSetting";
import { loginActions } from "../../../LoginPage/reducer";
import stylesContainer from "../../style.module.scss";
import styles from './style.module.scss';
import Vessels from "./Vessels";

interface IProps {
    actions: any
}

const ViewModes: React.FC<IProps> = ({ actions }) => {
    const dispatch = useDispatch();
    const [mode, setMode] = useState(selectViewMode(getStore()));

    const changeMode = (type: VIEW_MODE) => {
        setMode(type)
        dispatch(loginActions.updateUserSetting([{ [PreferenceSetting.VIEW_MODE]: type }]))
    }

    return <>
        <div className={stylesContainer.header}>
            <div className={stylesContainer.title}>
                View modes
            </div>
        </div>
        <div className={styles.wrapper}>
            <div className={styles.line}>
                {viewModes.reduce((list: any[], item) => {
                    if (actions[item.id])
                        return [...list, <div
                            key={item.id}
                            className={[styles.mode, styles.checkboxFill].join(' ')}
                            data-actived={mode === item.id}
                            onClick={() => changeMode(item.id)}
                        >
                            {item.name}
                        </div>]
                    return list;
                }, [])}
            </div>
            {mode === VIEW_MODE.VESSEL && <>
                <div className={styles.divider}>
                    <Divider />
                </div>
                <div className={styles.wrapperVessel}>
                    <div className='text-[15px] mb-10'>Please select vessel to use</div>
                    <Vessels />
                </div>
            </>}
        </div>
    </>;
};

export default ViewModes;
